import type { LDClient } from "launchdarkly-react-client-sdk";

/**
 * The live LaunchDarkly client for code outside React (Apollo links, axios),
 * set by LaunchDarklyProvider once the SDK has a client.
 */
let ldClient: LDClient | undefined;

export function setLDClient(client: LDClient | undefined) {
  ldClient = client;
}

export function getLDClient() {
  return ldClient;
}
